import React, { useState, useRef, useEffect } from "react";
import moment from "moment";
import api from "../../services/api";
import { Link } from "react-router-dom";
import { useMenuAuthInfo, useMultiLang } from "../../services/GlobalUtil";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import FunctionButton from "../../components/common/FunctionButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import { useTranslation } from "react-i18next";
import SearchWrapDiv from "../../components/common/SearchWrapDiv";
import CustomDropDownTreeSelect from "../../components/common/CustomDropDownTreeSelect";
import CustomDatePicker from "../../components/common/CustomDatePicker";
import SearchButton from "../../components/common/SearchButton";
import PeriodQuickButtons from "../../components/common/PeriodQuickButtons";
import SupportFilterButtons from "../../components/common/SupportFilterButtons";
import DashboardDiv from "../../components/common/DashboardDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import ActiveButton from "../../components/common/ActiveButton";
import PageBar from "../../components/common/PageBar";
import PdiDetailPage from "./PdiDetailPage";
import FullModalDiv from "../../components/common/FullModalDiv";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";
import CodeSelectBox from "../../components/common/CodeSelectBox";

const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50].map((n) => ({
  code: n,
  codeDesc: String(n),
}));

const RegionalRecordPage = () => {
  const [pageSize, setPageSize] = useState(10);
  const [curPage, setCurPage] = useState(1);
  const [totalCount, setTotalCount] = useState();
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();

  const [startDate, setStartDate] = useState(
    moment().subtract(1, "week").add(1, "day").toDate()
  );
  const [endDate, setEndDate] = useState(moment().toDate());
  const [period, setPeriod] = useState("week");
  const [sbLocationDlr, setSbLocationDlr] = useState([]);
  const [sbCar, setSbCar] = useState([]);
  const sbInspType = useMultiLang("INSPECTION_TYPE");
  const [locationDlr, setLocationDlr] = useState([]);
  const [car, setCar] = useState([]);
  const [inspType, setInspType] = useState([]);
  const [supportFilter, setSupportFilter] = useState("ALL");

  const searchRegion = useRef([]);
  const searchCar = useRef([]);
  const searchInspType = useRef([]);
  const searchSupportFilter = useRef("ALL");
  const searchStartDt = useRef(
    moment().subtract(1, "week").add(1, "day").format("YYYY-MM-DD 00:00:00")
  );
  const searchEndDt = useRef(moment().format("YYYY-MM-DD 00:00:00"));

  const [dash, setDash] = useState([]);
  const [datas, setDatas] = useState([]);

  const [viewId, setViewId] = useState("");
  const [isOpenDetail, setIsOpenDetail] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isExcelLoading, setIsExcelLoading] = useState(false);
  // 서버가 엑셀을 스트리밍으로 내려주므로 Content-Length 가 없다. 받은 바이트만 표시한다.
  const [excelLoadedBytes, setExcelLoadedBytes] = useState(0);

  useEffect(() => {
    if (menuAuthInfo?.view) {
      loadContentData();
    }
  }, [curPage, pageSize]);

  const loadLocationLocData = () => {
    if (sbLocationDlr != null && sbLocationDlr.length > 0) {
      return;
    }

    api
      .post("/common/location-loc-tree", {})
      .then((response) => {
        setSbLocationDlr(response.data);
      })
      .catch(() => {});
  };

  const fetchCarData = (filter) => {
    api
      .post("/common/car-tree", { sSupportFilter: filter })
      .then((response) => {
        setSbCar(response.data);
      })
      .catch(() => {});
  };

  const loadCarData = () => {
    if (sbCar != null && sbCar.length > 0) {
      return;
    }

    fetchCarData(supportFilter);
  };

  const handleSupportFilterSelect = (key) => {
    if (key === supportFilter) {
      return;
    }
    setSupportFilter(key);
    setCar([]);
    setSbCar([]);
    fetchCarData(key);

    // 지원/미지원 선택 시 통계와 리스트도 즉시 반영
    searchRegion.current = locationDlr;
    searchCar.current = [];
    searchInspType.current = inspType;
    searchSupportFilter.current = key;
    searchStartDt.current = moment(startDate).format("YYYY-MM-DD 00:00:00");
    searchEndDt.current = moment(endDate).format("YYYY-MM-DD 00:00:00");

    if (curPage === 1) {
      loadContentData();
    } else {
      setCurPage(1);
    }
  };

  const handleStartDateChange = (data) => {
    setStartDate(data);
    setPeriod("");
    if (moment(data).isAfter(moment(endDate))) {
      setEndDate(data);
    }
  };

  const handleEndDateChange = (data) => {
    setEndDate(data);
    setPeriod("");
    if (moment(data).isBefore(moment(startDate))) {
      setStartDate(data);
    }
  };

  const handlePeriodSelect = (start, end, key) => {
    setStartDate(start);
    setEndDate(end);
    setPeriod(key);

    searchRegion.current = locationDlr;
    searchCar.current = car;
    searchInspType.current = inspType;
    searchSupportFilter.current = supportFilter;
    searchStartDt.current = moment(start).format("YYYY-MM-DD 00:00:00");
    searchEndDt.current = moment(end).format("YYYY-MM-DD 00:00:00");

    if (curPage === 1) {
      loadContentData();
    } else {
      setCurPage(1);
    }
  };

  const loadContentData = () => {
    setIsLoading(true);

    api
      .post("/pdi-status/regional/stat", {
        sRegions: searchRegion.current,
        sVehicles: searchCar.current,
        sInspTypes: searchInspType.current,
        sSupportFilter: searchSupportFilter.current,
        sStartDate: searchStartDt.current,
        sEndDate: searchEndDt.current,
        page: curPage,
        size: pageSize,
      })
      .then((response) => {
        setDash(response.data);
      })
      .catch(() => {});

    api
      .post("/pdi-status/regional/view", {
        sRegions: searchRegion.current,
        sVehicles: searchCar.current,
        sInspTypes: searchInspType.current,
        sSupportFilter: searchSupportFilter.current,
        sStartDate: searchStartDt.current,
        sEndDate: searchEndDt.current,
        page: curPage,
        size: pageSize,
      })
      .then((response) => {
        setDatas(response.data.content);
        setTotalCount(response.data.totalCount);
        setIsLoading(false);
      })
      .catch(() => {});
  };

  const pageChange = (data) => {
    if (curPage === data) {
      return;
    }
    setCurPage(data);
  };

  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setCurPage(1);
  };

  const handleSearch = () => {
    searchRegion.current = locationDlr;
    searchCar.current = car;
    searchInspType.current = inspType;
    searchSupportFilter.current = supportFilter;
    searchStartDt.current = moment(startDate).format("YYYY-MM-DD 00:00:00");
    searchEndDt.current = moment(endDate).format("YYYY-MM-DD 00:00:00");

    if (curPage === 1) {
      loadContentData();
    } else {
      setCurPage(1);
    }
  };

  const handleDownloadExcel = () => {
    if (isExcelLoading) {
      return;
    }
    setIsExcelLoading(true);
    setExcelLoadedBytes(0);
    api
      .post(
        "/pdi-status/regional/excel",
        {
          sRegions: searchRegion.current,
          sVehicles: searchCar.current,
          sInspTypes: searchInspType.current,
          sSupportFilter: searchSupportFilter.current,
          sStartDate: searchStartDt.current,
          sEndDate: searchEndDt.current,
        },
        {
          responseType: "blob",
          onDownloadProgress: (progressEvent) => {
            setExcelLoadedBytes(progressEvent.loaded || 0);
          },
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute(
          "download",
          "Regional_Records_" + moment().format("YYYYMMDD") + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        setIsExcelLoading(false);
      })
      .catch(() => {
        setIsExcelLoading(false);
      });
  };

  const handleOpenPopup = (viewId) => {
    setIsOpenDetail(true);
    setViewId(viewId);
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0053"), t("MENU:L0060")]}></BreadCrumbDiv>

      <SearchWrapDiv>
        <ButtonWrapDiv>
          <CustomDropDownTreeSelect
            data={sbLocationDlr}
            placeholder={t("L0049")}
            isViewCode={true}
            flattenIntermediate={true}
            onChange={setLocationDlr}
            onFocus={loadLocationLocData}
          ></CustomDropDownTreeSelect>
          <CustomDropDownTreeSelect
            key={`car-${supportFilter}`}
            data={sbCar}
            placeholder={t("L0672")}
            onChange={setCar}
            onFocus={loadCarData}
          ></CustomDropDownTreeSelect>
          <CustomDropDownTreeSelect
            data={sbInspType}
            placeholder={t("L0126")}
            onChange={setInspType}
          ></CustomDropDownTreeSelect>
        </ButtonWrapDiv>
        <ButtonWrapDiv className="btn_right">
          <CustomDatePicker
            defaultDate={startDate}
            maxDate={new Date()}
            onChange={(date) => handleStartDateChange(date)}
            dateFormat={"YYYY-MM-dd"}
          ></CustomDatePicker>
          <div>
            <br />
            &nbsp;&nbsp;-&nbsp;&nbsp;
          </div>
          <CustomDatePicker
            defaultDate={endDate}
            maxDate={new Date()}
            onChange={(date) => handleEndDateChange(date)}
            dateFormat={"YYYY-MM-dd"}
          ></CustomDatePicker>

          <SearchButton onClick={handleSearch}></SearchButton>
        </ButtonWrapDiv>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <SupportFilterButtons
            selected={supportFilter}
            onSelect={handleSupportFilterSelect}
          />
          <PeriodQuickButtons selected={period} onSelect={handlePeriodSelect} />
        </div>
      </SearchWrapDiv>

      <ButtonWrapDiv className="btn_top">
        <FunctionButton
          value={
            isExcelLoading && excelLoadedBytes > 0
              ? `${t("L0150")} (${(excelLoadedBytes / 1048576).toFixed(1)} MB)`
              : t("L0150")
          }
          onClick={handleDownloadExcel}
          loading={isExcelLoading}
        ></FunctionButton>
      </ButtonWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <DashboardDiv>
          <dl>
            <dt>{t("L0192")}</dt>
            <dd>{dash.totalCount ? dash.totalCount.toLocaleString() : "0"}</dd>
          </dl>
          <dl>
            <dt>{t("L1090")}</dt>
            <dd>{dash.goodCount ? dash.goodCount.toLocaleString() : "0"}</dd>
          </dl>
          <dl>
            <dt>{t("L0332")}</dt>
            <dd>{dash.ngCount ? dash.ngCount.toLocaleString() : "0"}</dd>
          </dl>
          <dl>
            <dt>{t("L0666")}</dt>
            <dd>{dash.ngRatio ? `${dash.ngRatio}%` : "0%"}</dd>
          </dl>
          <dl>
            <dt>{t("L0667")}</dt>
            <dd>{dash.avgItem ? dash.avgItem.toLocaleString() : "0"}</dd>
          </dl>
          <dl>
            <dt>{t("L0668")}</dt>
            <dd>
              {dash.avgTime
                ? `${Math.floor(dash.avgTime / 60)}’ ${(dash.avgTime % 60)
                    .toString()
                    .padStart(2, "0")}”`
                : "0’ 00”"}
            </dd>
          </dl>
        </DashboardDiv>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginBottom: "10px",
          }}
        >
          <CodeSelectBox
            value={pageSize}
            codes={PAGE_SIZE_OPTIONS}
            onChange={handlePageSizeChange}
            width="64px"
            style={{
              border: "1px solid #ccc",
              borderRadius: "3px",
              padding: "0 5px",
              height: "28px",
              fontSize: "12px",
            }}
          ></CodeSelectBox>
        </div>

        <ListWrapDiv>
          <table>
            <colgroup>
              <col style={{ width: "3%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "9%" }} />
            </colgroup>
            <thead>
              <tr>
                <th>{t("L0130")}</th>
                <th>{t("L0672")}</th>
                <th>{t("L0126")}</th>
                <th>{t("L0671")}</th>
                <th>{t("L0151")}</th>
                <th>{t("L0120")}</th>
                <th>{t("L0113")}</th>
                <th>{t("L0153")}</th>
                <th>{t("L0154")}</th>
                <th>{t("L0669")}</th>
                <th>{t("L0228")}</th>
                <th>{t("L0156")}</th>
              </tr>
            </thead>
            <tbody>
              {datas.length === 0 ? (
                <tr>
                  <td colSpan={13} style={{ textAlign: "center" }}>
                    {t("L0094")}
                    <br />
                    {t("L0095")}
                  </td>
                </tr>
              ) : (
                datas.map((data, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{data.rowNum}</td>
                    <td>{data.vehicle}</td>
                    <td>{data.inspTypeDesc}</td>
                    <td>
                      {menuAuthInfo.view ? (
                        <Link to="#" onClick={() => handleOpenPopup(data.id)}>
                          {data.vin}
                        </Link>
                      ) : (
                        <span>{data.vin}</span>
                      )}
                    </td>
                    <td>
                      {data.inspDate
                        ? moment(data.inspDate).format("YYYY-MM-DD HH:mm:ss")
                        : ""}
                    </td>
                    <td>{data.locType}</td>
                    <td>{data.loc}</td>
                    <td>{data.testItemCount}</td>
                    <td>{data.ngItemCount}</td>
                    <td>
                      <ActiveButton
                        isActive={!data.inspResult}
                        style={{
                          cursor: "default",
                        }}
                      ></ActiveButton>
                    </td>
                    <td>{data.inspTime2}</td>
                    <td>{data.inspector}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </ListWrapDiv>

        <PageBar
          TotalCount={totalCount}
          CurrentPage={curPage}
          CountPerPage={pageSize}
          MaxPageBarCount={10}
          onPageСhange={pageChange}
        ></PageBar>
      </LoadingBoxDiv>

      <FullModalDiv
        isOpen={isOpenDetail}
        onClose={() => setIsOpenDetail(false)}
      >
        <PdiDetailPage sId={viewId} />
      </FullModalDiv>
    </div>
  );
};

export default RegionalRecordPage;
